"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames7 = _interopRequireDefault(require("classnames"));

var _config = require("./config");

var _depCheck = _interopRequireDefault(require("../../dep-check"));

var _lunaIcon = _interopRequireWildcard(require("../luna-icon"));

var _lunaIconAction = _interopRequireWildcard(require("../luna-icon-action"));

var _lunaContainer = _interopRequireWildcard(require("../luna-container"));

var _lunaLoadingIndicator = _interopRequireWildcard(require("../luna-loading-indicator"));

var _lunaTag = _interopRequireWildcard(require("../luna-tag"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LunaSearch = _react["default"].forwardRef(function (props, ref) {
  (0, _depCheck["default"])([]);
  var className = props.className,
      defaultValue = props.defaultValue,
      id = props.id,
      infoBoxAction = props.infoBoxAction,
      isDisabled = props.isDisabled,
      isLoading = props.isLoading,
      name = props.name,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onSearch = props.onSearch,
      onSelectResult = props.onSelectResult,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      placeholder = props.placeholder,
      searchableItems = props.searchableItems,
      searchResult = props.searchResult,
      size = props.size,
      other = props.other,
      value = props.value;

  if (!searchableItems && !searchResult) {
    throw new Error('LunaSearch: must include either searchableItems or searchResult prop in order to search items or results.');
  }

  if (searchableItems && searchResult) {
    throw new Error('LunaSearch: the searchableItems and searchResult props are mutually exclusive, please choose one.');
  }

  if (isLoading && !searchResult) {
    throw new Error('LunaSearch: the searchResult prop is required when setting a loading state.');
  }

  var _isControlled = !!value;

  var _initialValue = defaultValue || value || '';

  var _useState = (0, _react.useState)(_initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      _value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      _completedValue = _useState4[0],
      setCompletedValue = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      _isInfoBoxOpen = _useState6[0],
      setInfoBoxOpen = _useState6[1];

  var _useState7 = (0, _react.useState)(searchableItems),
      _useState8 = _slicedToArray(_useState7, 2),
      _searchableItems = _useState8[0],
      setSearchableItems = _useState8[1];

  var _useState9 = (0, _react.useState)(0),
      _useState10 = _slicedToArray(_useState9, 2),
      _tabIndex = _useState10[0],
      setTabIndex = _useState10[1];

  var _onChange = function _onChange(event) {
    if (!_isControlled) {
      setValue(event.target.value);

      if (!_isInfoBoxOpen) {
        setInfoBoxOpen(true);
      }
    }
  };

  var searchValInString = function searchValInString(searchedVal, str) {
    return str.toUpperCase().includes(searchedVal);
  };

  var itemHasMatchingTerm = function itemHasMatchingTerm(item, searchedVal) {
    if (item.label) {
      if (searchValInString(searchedVal, item.label)) {
        return true;
      } else if (item.details && item.details.some(function (detail) {
        return searchValInString(searchedVal, detail.value.toString());
      })) {
        return true;
      } else {
        return false;
      }
    }
  };

  var filterSearchableItems = function filterSearchableItems(items) {
    var uppercaseValue = _value.toUpperCase();

    if (items && items.length) {
      var ofTypeGroup = items[0].groupItems;
      return items.filter(function (item) {
        if (ofTypeGroup) {
          var filteredGroupItems = item.groupItems.filter(function (groupItem) {
            return itemHasMatchingTerm(groupItem, uppercaseValue);
          });
          item.filteredGroupItems = filteredGroupItems;
          return filteredGroupItems.length;
        } else {
          return itemHasMatchingTerm(item, uppercaseValue);
        }
      });
    }
  };

  (0, _react.useEffect)(function () {
    if (_value) {
      if (searchableItems) {
        setSearchableItems(filterSearchableItems(searchableItems));
      }
    } else {
      setInfoBoxOpen(false);
    }
  }, [_value]);

  var useDebounce = function useDebounce(value, delay) {
    var _useState11 = (0, _react.useState)(value),
        _useState12 = _slicedToArray(_useState11, 2),
        _debouncedValue = _useState12[0],
        setDebouncedValue = _useState12[1];

    (0, _react.useEffect)(function () {
      var handler = setTimeout(function () {
        setDebouncedValue(value);
      }, delay);
      return function () {
        clearTimeout(handler);
      };
    }, [value, delay]);
    return _debouncedValue;
  };

  var debouncedSearch = useDebounce(_value, 300);

  var handleSearch = function handleSearch() {
    if (_value) {
      onSearch(_value);
      setCompletedValue(_value);
    }
  };

  (0, _react.useEffect)(handleSearch, [debouncedSearch]);
  (0, _react.useEffect)(function () {
    if (searchResult) {
      if (searchResult.noResults) {
        setSearchableItems([]);
      } else {
        setSearchableItems(filterSearchableItems(searchResult.results));
      }
    }
  }, [searchResult]);

  var _onFocus = function _onFocus(event) {
    if (onFocus) {
      onFocus(event);
    }

    if (_value && !_isInfoBoxOpen) {
      setInfoBoxOpen(true);
    }
  };

  var _handleClear = function _handleClear() {
    setValue('');
    setInfoBoxOpen(false);
    setCompletedValue(null);
  };

  var searchEl = (0, _react.useRef)(null);
  var inputEl = (0, _react.useRef)(null);

  var handleClose = function handleClose(event) {
    event.preventDefault();
    if (!_isControlled) inputEl.current.blur();
    setTabIndex(0);
    setInfoBoxOpen(false);
  };

  var handleSelect = function handleSelect(event, selected, searchItems, type) {
    onSelectResult(selected, searchItems);
    var newVal = type === 'subtype' ? selected.parentItem.label : selected.selectedItem.label;
    setValue(newVal);
    handleClose(event);
  };

  var handleExternalEvents = function handleExternalEvents(event) {
    var infoBoxItemActionIsActive = _config.classes.infoBoxItemActionIsActive;

    if (!_isInfoBoxOpen) {
      return;
    }

    if (searchEl.current && !searchEl.current.contains(event.target) && !inputEl.current.contains(event.target)) {
      setInfoBoxOpen(false);
    }

    if (event.key === 'Escape') {
      handleClose(event);
    }

    if (event.key === 'ArrowDown' || event.key === 'Down' || event.key === 'ArrowUp' || event.key === 'Up') {
      var active = document.activeElement;

      if (active.tagName === 'INPUT') {
        var firstEl = document.getElementById("first-list-element-".concat(id));

        if (firstEl) {
          firstEl.focus();
          firstEl.classList.add(infoBoxItemActionIsActive);
        }
      } else {
        event.preventDefault();
        var tabbables = document.querySelectorAll(".tabbable");
        var curIdx = _tabIndex;
        var delta = event.key === ('ArrowUp' || 'Up') ? -1 : 1;
        var toIndex = curIdx + delta;

        if (toIndex >= 0 && toIndex <= tabbables.length - 1) {
          setTabIndex(toIndex);
          tabbables[toIndex].focus();
          tabbables[toIndex].classList.add(infoBoxItemActionIsActive);
          tabbables[curIdx].classList.remove(infoBoxItemActionIsActive);
        }
      }
    }
  };

  (0, _react.useEffect)(function () {
    document.addEventListener('keydown', handleExternalEvents, true);
    document.addEventListener('click', handleExternalEvents, true);
    return function () {
      document.removeEventListener('keydown', handleExternalEvents, true);
      document.removeEventListener('click', handleExternalEvents, true);
    };
  });

  var getClassList = function getClassList() {
    var _classnames;

    var base = _config.classes.base,
        sizes = _config.classes.sizes,
        disabledClass = _config.classes.isDisabled,
        populatedClass = _config.classes.isPopulated;
    return (0, _classnames7["default"])((_classnames = {}, _defineProperty(_classnames, base, true), _defineProperty(_classnames, disabledClass, isDisabled), _defineProperty(_classnames, populatedClass, _completedValue && _isInfoBoxOpen), _defineProperty(_classnames, sizes.s20, size ? size === _config.LunaSearchSizes.s20 : true), _defineProperty(_classnames, sizes.s10, size === _config.LunaSearchSizes.s10), _classnames), className);
  };

  var getInputClassList = function getInputClassList() {
    var _classnames2;

    var inputBase = _config.classes.inputBase,
        inputSmall = _config.classes.inputSmall;
    return (0, _classnames7["default"])((_classnames2 = {}, _defineProperty(_classnames2, inputBase, true), _defineProperty(_classnames2, inputSmall, size === _config.LunaSearchSizes.s10), _classnames2));
  };

  var getIconClassList = function getIconClassList() {
    var _classnames3;

    var actionClear = _config.classes.actionClear,
        actionSearch = _config.classes.actionSearch;
    return (0, _classnames7["default"])((_classnames3 = {}, _defineProperty(_classnames3, actionClear, _completedValue && _isInfoBoxOpen), _defineProperty(_classnames3, actionSearch, _value && !_completedValue || _value && !_isInfoBoxOpen || !_value), _classnames3));
  };

  var getInfoBoxActionClasslist = function getInfoBoxActionClasslist() {
    var infoBoxAction = _config.classes.infoBoxAction,
        infoBoxItem = _config.classes.infoBoxItem,
        infoBoxItemSeparator = _config.classes.infoBoxItemSeparator;
    return (0, _classnames7["default"])(infoBoxAction, infoBoxItem, infoBoxItemSeparator);
  };

  var getInfoBoxActionComponentClassList = function getInfoBoxActionComponentClassList() {
    var _classnames4;

    var infoBoxItemAction = _config.classes.infoBoxItemAction;
    var linkComponentClassList = infoBoxAction.componentProps && infoBoxAction.componentProps.className;
    return (0, _classnames7["default"])((_classnames4 = {}, _defineProperty(_classnames4, infoBoxItemAction, true), _defineProperty(_classnames4, linkComponentClassList, linkComponentClassList), _classnames4));
  };

  var getInfoBoxItemClassList = function getInfoBoxItemClassList(item, groupLabelSeparator) {
    var _classnames5;

    var infoBoxItem = _config.classes.infoBoxItem,
        groupTitle = _config.classes.groupTitle,
        infoBoxItemSeparator = _config.classes.infoBoxItemSeparator;
    return (0, _classnames7["default"])((_classnames5 = {}, _defineProperty(_classnames5, infoBoxItem, true), _defineProperty(_classnames5, groupTitle, item.groupLabel), _defineProperty(_classnames5, infoBoxItemSeparator, groupLabelSeparator), _classnames5));
  };

  var getInfoBoxItemActionClassList = function getInfoBoxItemActionClassList(item, isSubtype) {
    var _classnames6;

    var infoBoxItemAction = _config.classes.infoBoxItemAction,
        infoBoxItemActionIsActive = _config.classes.infoBoxItemActionIsActive,
        infoBoxItemActionIsDisabled = _config.classes.infoBoxItemActionIsDisabled,
        infoBoxItemActionSubtype = _config.classes.infoBoxItemActionSubtype;
    return (0, _classnames7["default"])((_classnames6 = {}, _defineProperty(_classnames6, infoBoxItemAction, true), _defineProperty(_classnames6, "tabbable", true), _defineProperty(_classnames6, infoBoxItemActionIsDisabled, item.isDisabled), _defineProperty(_classnames6, infoBoxItemActionIsActive, item.isActive), _defineProperty(_classnames6, infoBoxItemActionSubtype, isSubtype), _classnames6));
  };

  var getComponentIcon = function getComponentIcon() {
    var iconSize = size === _config.LunaSearchSizes.s10 ? _lunaIcon.LunaIconSizes.s20 : _lunaIcon.LunaIconSizes.s30;

    if (_completedValue && _isInfoBoxOpen) {
      return _react["default"].createElement(_lunaIconAction["default"], {
        type: _lunaIconAction.LunaIconActionTypes.t5,
        size: _lunaIconAction.LunaIconActionSizes.s10,
        className: getIconClassList(),
        glyph: _lunaIcon.LunaGlyphs['cross'],
        onClick: _handleClear
      });
    } else {
      return _react["default"].createElement("span", {
        className: "luna-form_control--action_search"
      }, _react["default"].createElement(_lunaIcon["default"], {
        size: iconSize,
        className: getIconClassList(),
        glyph: _lunaIcon.LunaGlyphs['search']
      }));
    }
  };

  var _componentIcon = getComponentIcon();

  var getInfoBoxActionComponent = function getInfoBoxActionComponent() {
    var component = infoBoxAction.component,
        componentProps = infoBoxAction.componentProps,
        icon = infoBoxAction.icon,
        handleClick = infoBoxAction.handleClick,
        label = infoBoxAction.label;
    var infoBoxItemAction = _config.classes.infoBoxItemAction;
    var InfoBoxActionComponent = component || 'button';

    var infoBoxActionComponentProps = _objectSpread(_objectSpread({}, componentProps), {}, {
      className: componentProps ? getInfoBoxActionComponentClassList() : infoBoxItemAction
    });

    return infoBoxAction ? _react["default"].createElement("div", {
      className: getInfoBoxActionClasslist()
    }, _react["default"].createElement(InfoBoxActionComponent, _extends({}, infoBoxActionComponentProps, {
      onClick: handleClick
    }), label, _react["default"].createElement(_lunaIcon["default"], {
      size: _lunaIcon.LunaIconSizes.s20,
      glyph: icon
    }))) : '';
  };

  var _infoBoxActionComponent = infoBoxAction && _searchableItems.length ? getInfoBoxActionComponent() : '';

  var getInfoBoxActionTags = function getInfoBoxActionTags(item) {
    if (item.tags) {
      return item.tags.map(function (tag, tagIdx) {
        return _react["default"].createElement(_lunaTag["default"], _extends({}, tag, {
          type: _lunaTag.LunaTagTypes.tag30,
          size: _lunaTag.LunaTagSizes["default"],
          key: "tag-".concat(tagIdx)
        }));
      });
    }
  };

  var getInfoBoxActionDetailMatch = function getInfoBoxActionDetailMatch(detail, idx, detailIdx) {
    var detailLabel = "".concat(detail.label, " ").concat(detail.value);

    var uppercaseValue = _value.toUpperCase();

    var uppercaseDetailLabel = detailLabel.toUpperCase();
    var newLabel = {
      detailLabel: detailLabel
    };

    if (_value) {
      var startIdxOfMatch = uppercaseDetailLabel.indexOf(uppercaseValue);
      var endIdxOfMatch = startIdxOfMatch + _value.length;
      var startIdxOfMatchValue = detail.value.toString().toUpperCase().indexOf(uppercaseValue);
      var endIdxOfMatchValue = startIdxOfMatchValue + _value.length;
      var firstLabelSection = startIdxOfMatch !== 0 ? detailLabel.slice(0, startIdxOfMatch) : '';
      var lastLabelSection = endIdxOfMatch !== detailLabel.length ? detailLabel.slice(endIdxOfMatch) : '';
      var textMatchLabelSection = getInfoBoxItemTextMatch(detailLabel.slice(startIdxOfMatch, endIdxOfMatch), idx, detailIdx);

      if (startIdxOfMatch > -1) {
        newLabel.detailLabel = [firstLabelSection, textMatchLabelSection, lastLabelSection];
        newLabel.matchIndices = [startIdxOfMatchValue, endIdxOfMatchValue];
        return newLabel;
      } else {
        return newLabel;
      }
    } else {
      return newLabel;
    }
  };

  var getInfoBoxActionDetails = function getInfoBoxActionDetails(item, idx, detailItemIdx) {
    var detailMatches = [];

    if (item.details) {
      return [_react["default"].createElement("span", {
        className: "luna-form_control--info_box_item_action_details"
      }, item.details.map(function (detail, detailIdx) {
        var itemLabel = getInfoBoxActionDetailMatch(detail, idx, detailIdx);
        var searchMatchIndices = itemLabel.matchIndices;
        var searchMatchIndicesString = searchMatchIndices ? "".concat(itemLabel.matchIndices[0], ":").concat(itemLabel.matchIndices[1]) : '';
        var detailSearchMatchPathString = "[".concat(detailItemIdx, "].details[").concat(detailIdx, "].value");
        detailMatches.push([detailSearchMatchPathString, searchMatchIndicesString]);
        return _react["default"].createElement("span", {
          className: "luna-form_control--info_box_item_action_detail",
          key: "detail-".concat(detailIdx)
        }, itemLabel.detailLabel);
      })), detailMatches];
    }
  };

  var getInfoBoxGroupItemComponent = function getInfoBoxGroupItemComponent(item, idx) {
    var groupComponent = [];
    var groupLabelSeparator = idx !== 0;
    groupComponent.push(_react["default"].createElement("li", {
      className: getInfoBoxItemClassList(item, groupLabelSeparator),
      key: "group-label-".concat(idx)
    }, item.groupLabel));

    if (item.filteredGroupItems) {
      groupComponent.push(item.filteredGroupItems.map(function (currGroupItem, currGroupIdx) {
        return getInfoBoxItemComponent(currGroupItem, currGroupIdx, item, idx);
      }));
    }

    return groupComponent;
  };

  var getInfoBoxItemTextMatch = function getInfoBoxItemTextMatch(match, idx, detailIdx) {
    if (detailIdx) {
      return _react["default"].createElement("span", {
        className: "luna-form_control--text_match",
        key: "match-".concat(idx, "-detail-").concat(detailIdx)
      }, match);
    } else {
      return _react["default"].createElement("span", {
        className: "luna-form_control--text_match",
        key: "match-".concat(idx)
      }, match);
    }
  };

  var getInfoBoxItemLabel = function getInfoBoxItemLabel(label, idx) {
    var uppercaseValue = _value.toUpperCase();

    var uppercaseLabel = label.toUpperCase();
    var newLabel = {
      label: label
    };

    if (_value) {
      var startIdxOfMatch = uppercaseLabel.indexOf(uppercaseValue);
      var endIdxOfMatch = startIdxOfMatch + _value.length;
      var firstLabelSection = startIdxOfMatch !== 0 ? label.slice(0, startIdxOfMatch) : '';
      var lastLabelSection = endIdxOfMatch !== label.length ? label.slice(endIdxOfMatch) : '';
      var textMatchLabelSection = getInfoBoxItemTextMatch(label.slice(startIdxOfMatch, endIdxOfMatch), idx);

      if (startIdxOfMatch > -1) {
        newLabel.label = [firstLabelSection, textMatchLabelSection, lastLabelSection];
        newLabel.matchIndices = [startIdxOfMatch, endIdxOfMatch];
        return newLabel;
      } else {
        return newLabel;
      }
    } else {
      return newLabel;
    }
  };

  var getInfoBoxItemComponent = function getInfoBoxItemComponent(item, idx, groupItem, groupIdx) {
    var searchItems = searchableItems || searchResult;
    var searchItemsList = searchResult && searchResult.results ? searchResult.results : searchableItems;
    var selectedItemIndex = searchItemsList.indexOf(item);
    var selectedGroupIndex = searchItemsList.indexOf(groupItem);
    var groupSelectedItemIndex = groupItem ? searchItemsList[selectedGroupIndex].groupItems.indexOf(item) : null;
    var itemLabel = getInfoBoxItemLabel(item.label, idx);
    var searchMatchIndices = itemLabel.matchIndices;
    var searchMatchIndicesString = searchMatchIndices ? "".concat(itemLabel.matchIndices[0], ":").concat(itemLabel.matchIndices[1]) : '';
    var searchMatchPathString = searchMatchIndices ? "[".concat(selectedItemIndex, "].label") : '';
    var groupSearchMatchPathString = searchMatchIndices ? "[".concat(selectedGroupIndex, "].groupItems[").concat(selectedGroupIndex, "].label") : '';
    var detailSearchMatch = getInfoBoxActionDetails(item, idx, selectedItemIndex);
    var infoBoxItemComponentItems = [];
    var selected = {
      selectedItem: item,
      selectedItemIndex: groupItem ? groupSelectedItemIndex : selectedItemIndex,
      selectedItemSearchMatch: groupItem ? [groupSearchMatchPathString, searchMatchIndicesString] : [searchMatchPathString, searchMatchIndicesString],
      selectedItemDetailSearchMatch: detailSearchMatch ? detailSearchMatch[1] : null,
      parentItem: null,
      parentIndex: null,
      groupItem: groupItem || null,
      groupIndex: groupItem ? selectedGroupIndex : null
    };

    var handleClick = function handleClick(event) {
      if (!item.isDisabled) {
        handleSelect(event, selected, searchItems);
      }
    };

    infoBoxItemComponentItems.push(_react["default"].createElement("li", {
      className: getInfoBoxItemClassList(item),
      key: groupIdx ? "group-item-".concat(groupIdx, "-").concat(idx) : " info-box-item-".concat(idx)
    }, _react["default"].createElement("button", {
      className: getInfoBoxItemActionClassList(item),
      onClick: function onClick(event) {
        return handleClick(event);
      },
      id: idx === 0 ? "first-list-element-".concat(id) : "item-".concat(idx)
    }, itemLabel.label, getInfoBoxActionTags(item), detailSearchMatch ? detailSearchMatch[0] : null)));

    if (item.subtypes) {
      var subtypeItems = item.subtypes.map(function (subtype, subtypeIdx) {
        var selectedSubtype = _objectSpread(_objectSpread({}, selected), {}, {
          selectedItem: subtype,
          selectedItemIndex: subtypeIdx,
          parentItem: item,
          parentIndex: idx
        });

        return _react["default"].createElement("li", {
          className: getInfoBoxItemClassList(item),
          key: "subtype-".concat(subtypeIdx)
        }, _react["default"].createElement("button", {
          className: getInfoBoxItemActionClassList(item, true),
          onClick: function onClick(event) {
            return handleSelect(event, selectedSubtype, searchItems, 'subtype');
          }
        }, "in ", subtype.label));
      });
      return [].concat(infoBoxItemComponentItems, _toConsumableArray(subtypeItems));
    } else {
      return infoBoxItemComponentItems;
    }
  };

  var getInfoBoxItemActions = function getInfoBoxItemActions(items) {
    if (items && items.length) {
      return items.map(function (item, itemIdx) {
        return item.groupLabel ? getInfoBoxGroupItemComponent(item, itemIdx) : getInfoBoxItemComponent(item, itemIdx);
      });
    } else {
      return _react["default"].createElement("li", {
        className: "luna-form_control--info_box_item luna-form_control-search--no_results"
      }, "No Results");
    }
  };

  var _infoBoxComponent = _isInfoBoxOpen ? isLoading ? _react["default"].createElement("div", {
    className: _config.classes.infoBoxBase
  }, _react["default"].createElement(_lunaContainer["default"], {
    padding: [_lunaContainer.LunaContainerPaddings.l10.all]
  }, _react["default"].createElement(_lunaLoadingIndicator["default"], {
    size: _lunaLoadingIndicator.LunaLoadingIndicatorSizes.size10
  }))) : _react["default"].createElement("div", {
    className: _config.classes.infoBoxBase
  }, _react["default"].createElement("ul", {
    className: _config.classes.infoBoxList
  }, getInfoBoxItemActions(_searchableItems)), _infoBoxActionComponent) : null;

  return _react["default"].createElement("div", _extends({}, other, {
    className: getClassList(),
    onBlur: onBlur,
    onClick: onClick,
    onFocus: _onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onMouseDown: onMouseDown,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    onTouchEnd: onTouchEnd,
    onTouchMove: onTouchMove,
    onTouchStart: onTouchStart,
    ref: searchEl
  }), _react["default"].createElement("input", {
    className: getInputClassList(),
    type: "search",
    value: _value,
    placeholder: placeholder,
    id: id,
    name: name,
    disabled: isDisabled,
    onChange: _onChange,
    ref: inputEl
  }), _componentIcon, _infoBoxComponent);
});

LunaSearch.propTypes = {
  className: _propTypes["default"].string,
  defaultValue: _propTypes["default"].string,
  isDisabled: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  infoBoxAction: _propTypes["default"].object,
  isLoading: _propTypes["default"].bool,
  name: _propTypes["default"].string,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onSearch: _propTypes["default"].func.isRequired,
  onSelectResult: _propTypes["default"].func.isRequired,
  onTouchEnd: _propTypes["default"].func,
  onTouchMove: _propTypes["default"].func,
  onTouchStart: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  searchableItems: _propTypes["default"].array,
  searchResult: _propTypes["default"].exact({
    noResults: _propTypes["default"].bool,
    results: _propTypes["default"].array
  }),
  size: _propTypes["default"].oneOf(Object.values(_config.LunaSearchSizes)),
  value: _propTypes["default"].string
};
LunaSearch.defaultProps = {
  other: {}
};
LunaSearch.displayName = 'LunaSearch';
var _default = LunaSearch;
exports["default"] = _default;
